<template lang="pug">
    div.expandCard
        table
            tr
                td {{ $t('fields.email') }}
                td {{ item.email }}

            tr(v-if="isAdmin")
                td {{ $t('fields.businessName') }}
                td {{ item.business && item.business.name ? item.business.name : '' }}

            tr(v-if="item.phone && isChampion")
                td {{ $t('fields.phone') }}
                td {{ item.phone | phoneNumber }}

            tr
                td {{ $t('fields.status') }}
                td {{ item.isActive ? $t('fields.active') : $t('fields.inactive') }}

            tr(v-if="isAdmin && item.subscription")
                td {{ $t('fields.coupon') }}
                td {{ item.subscription ? item.subscription.coupon : '' }}

            tr(v-if="isChampion")
                td {{ $t('fields.country') }}
                td {{ item.country }}

            tr(v-if="isChampion")
                td {{ $t('fields.city') }}
                td {{ item.city }}

            tr(v-if="isChampion")
                td {{ $t('fields.state') }}
                td {{ item.state }}

            tr(v-if="item.department && isChampion")
                td {{ $t('fields.department') }}
                td {{ item.department }}

            fragment(v-if="item.additionalInformation")
                tr( v-for="(item, index) in item.additionalInformation" :key="item.id")
                    td.capitalize
                        span(v-if="customFields.length && customFields[index] && customFields[index].label") {{ customFields[index].label }}
                    td {{ item.value }}
</template>

<script>
    import VueTypes from 'vue-types';

    import formattedDate from '~filters/FormattedDate';
    import phoneNumber from '~filters/Phone';
    import { mapGetters } from 'vuex';

    export default {
        filters: {
            formattedDate,
            phoneNumber
        },
        props: {
            item: VueTypes.object.def({}),
            customFields: VueTypes.array.def([])
        },
        computed: {
            ...mapGetters('auth', ['isChampion', 'isAdmin'])
        }
    };
</script>
